module.exports = __webpack_public_path__ + "static/img_1334-ee5cb61743ca8cc00c47dac116f0a223.webp";